import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const OutdoorRecreactionIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "OutdoorRecreactionIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.5374 19.4375H20.4169V18.5105H21.0333C21.2883 18.5105 21.4959 18.3029 21.4959 18.048V16.1192C21.4959 15.8643 21.2883 15.6567 21.0333 15.6567H19.9339V14.8713H20.6456C20.9006 14.8713 21.1082 14.6636 21.1082 14.4087V12.48C21.1082 12.225 20.9006 12.0174 20.6456 12.0174H19.9339V11.7226C19.9339 11.4676 19.7263 11.26 19.4713 11.26C19.2163 11.26 19.0087 11.4676 19.0087 11.7226V12.0174H13.8226V11.7226C13.8226 11.4676 13.615 11.26 13.36 11.26C13.105 11.26 12.8974 11.4676 12.8974 11.7226V12.0174H12.6003C12.5904 11.2296 12.3108 10.4694 11.8096 9.8676C11.9646 9.5091 12.0459 9.11494 12.0459 8.72429C12.0459 7.13769 10.7546 5.84643 9.16805 5.84643C8.61774 5.84643 8.08966 5.99906 7.63174 6.28855C7.5446 4.8154 6.31007 3.63818 4.81879 3.63818C3.26436 3.63818 2 4.90254 2 6.45639V12.3957C2 13.7683 3.00822 14.952 4.35621 15.1759V19.4375H2.46259C2.20761 19.4375 2 19.6451 2 19.9001C2 20.155 2.20761 20.3626 2.46259 20.3626H21.5374C21.7924 20.3626 22 20.155 22 19.9001C22 19.6451 21.7924 19.4375 21.5374 19.4375ZM19.4917 18.5105V19.4375H13.3395V18.5105H19.4917ZM20.5707 16.5818V17.5854H12.2605V16.5818H20.5707ZM9.63064 15.4602C10.4424 15.3508 11.1763 14.9596 11.7231 14.3484V14.4087C11.7231 14.6636 11.9307 14.8713 12.1857 14.8713H12.8974V15.6567H11.798C11.543 15.6567 11.3354 15.8643 11.3354 16.1193V18.048C11.3354 18.3029 11.543 18.5106 11.798 18.5106H12.4144V19.4375H9.63065L9.63064 15.4602ZM9.16805 10.6068C8.91307 10.6068 8.70546 10.8144 8.70546 11.0694V14.5239C8.16392 14.4239 7.66917 14.1449 7.29956 13.7309C7.52062 13.3221 7.637 12.8618 7.637 12.3958V7.51257C8.0107 7.04121 8.56744 6.77161 9.16805 6.77161C10.2447 6.77161 11.1207 7.64766 11.1207 8.72429C11.1207 9.07283 11.0289 9.41378 10.8546 9.71028C10.747 9.89333 10.7774 10.1249 10.9283 10.274C11.4102 10.7489 11.6751 11.3828 11.6751 12.0595C11.6751 13.2595 10.802 14.3034 9.63063 14.5239V13.1221L10.5119 12.2413C10.6921 12.0606 10.6921 11.7676 10.5119 11.5869C10.3306 11.4068 10.0382 11.4068 9.85694 11.5869L9.63062 11.8138V11.0694C9.63062 10.8144 9.42302 10.6068 9.16805 10.6068ZM12.6483 13.9461V12.9426H20.183V13.9461H12.6483ZM19.0087 14.8713V15.6567H13.8226V14.8713H19.0087ZM5.28138 15.1759C5.82292 15.0865 6.31943 14.8438 6.72529 14.4701C7.25688 15.011 7.95515 15.3607 8.70546 15.4607V19.4375H5.28138V15.1759ZM4.81879 8.96349C4.56381 8.96349 4.3562 9.1711 4.3562 9.42608V14.2321C3.52168 14.0221 2.92517 13.2636 2.92517 12.3958V6.4564C2.92517 5.41252 3.77491 4.56336 4.81879 4.56336C5.86268 4.56336 6.71183 5.41251 6.71183 6.4564V12.3958C6.71183 13.2636 6.11533 14.0215 5.28138 14.2321V9.42608C5.28138 9.1711 5.07377 8.96349 4.81879 8.96349Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default OutdoorRecreactionIcon;
